import snapInsights from './assets/SNAP-Insights.png';
import beverageBehaviors from './assets/Beverage-Behaviors.png';
import glp1 from './assets/GLP1.png';
import riskyRecall from './assets/Risky-Recall.png';

import styles from './_index.module.scss';

const ThoughtLeadership = () => {
  return (
    <div className={styles['thought-leadership']}>
      <h2>
        <strong>Thought Leadership</strong>
      </h2>
      <p>Know more about the changing omnichannel marketplace.</p>
      <hr></hr>
      <ul>
        <li>
          <a
            href="https://www.numerator.com/snap/?utm_source=insights.numerator.com&utm_medium=referral&utm_campaign=thought-leadership-dashboard"
            rel="noreferrer"
            target="_blank"
          >
            <img alt="SNAP Insights" src={snapInsights} />
            <small>INTERACTIVE INSIGHTS</small>
            <p>SNAP Insights</p>
          </a>
        </li>
        <li>
          <a
            href="https://www.numerator.com/resources/report/beverage-behaviors/?utm_source=insights.numerator.com&utm_medium=referral&utm_campaign=thought-leadership-dashboard"
            rel="noreferrer"
            target="_blank"
          >
            <img alt="Beverage Behaviors" src={beverageBehaviors} />
            <small>REPORT</small>
            <p>Beverage Behaviors</p>
          </a>
        </li>
        <li>
          <a
            href="https://www.numerator.com/resources/report/glp1-restaurant-behavior/?utm_source=insights.numerator.com&utm_medium=referral&utm_campaign=thought-leadership-dashboard"
            rel="noreferrer"
            target="_blank"
          >
            <img alt="GLP-1 Impact on Food Service" src={glp1} />
            <small>REPORT</small>
            <p>GLP-1 Impact on Food Service</p>
          </a>
        </li>
        <li>
          <a
            href="https://www.numerator.com/resources/white-paper/recall-risk-research/?utm_source=insights.numerator.com&utm_medium=referral&utm_campaign=thought-leadership-dashboard"
            rel="noreferrer"
            target="_blank"
          >
            <img alt="Risky Recall" src={riskyRecall} />
            <small>WHITEPAPER</small>
            <p>Risky Recall</p>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ThoughtLeadership;
